import { computed, Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class AuthComprasService {
  private _cpf = signal<string | null>(null);
  private _token = signal<string | null>(null);

  // Sinais públicos, somente para leitura, para acesso aos dados
  readonly cpf = this._cpf.asReadonly();
  readonly token = this._token.asReadonly();

  readonly isLoggedIn = computed(() => !!this._cpf() && !!this._token());

  setLoginData(userId: string, token: string): void {
    this._cpf.set(userId);
    this._token.set(token);
  }

  clearLoginData(): void {
    this._cpf.set(null);
    this._token.set(null);
  }
}
